import styled from '@emotion/styled';
import { Tabs } from '@innovationdepartment/proxima-ui';
import CreativeBriefs from 'components/CreativeBriefs';
import SectionLayout from 'ui/SectionLayout';
import Avatars from './Avatars';
import CastingProfile from './CastingProfile';
import type { CreativeEngineTab } from './CreativeEngine.types';
import { CREATIVE_ENGINE_TABS } from './CreativeEngine.types';

/* The sliding indicator animation janks while the newly selected tab's
   content mounts, so snap it to the active tab instead */
const TabsWrapper = styled.div`
  .MuiTabs-indicator {
    transition: none;
  }
`;

/* Both panels stay mounted so switching tabs never discards unsaved form edits;
   the inactive one is just hidden. */
const TabPanel = styled.div`
  &[hidden] {
    display: none;
  }
`;

type CreativeEngineViewProps = {
  activeTab: CreativeEngineTab;
  activatedTabs: Set<CreativeEngineTab>;
  onTabChange: (tab: CreativeEngineTab) => void;
};

const tabs = [
  { label: 'Creative Briefs', key: CREATIVE_ENGINE_TABS.CreativeBriefs },
  { label: 'Avatars', key: CREATIVE_ENGINE_TABS.Avatars },
  { label: 'Casting Profile', key: CREATIVE_ENGINE_TABS.CastingProfile }
];

const CreativeEngineView = ({ activeTab, activatedTabs, onTabChange }: CreativeEngineViewProps) => (
  <SectionLayout
    title="Creative Engine"
    headerContent={
      <TabsWrapper>
        <Tabs
          tabs={tabs}
          tab={activeTab}
          onChange={(tabKey: string) => onTabChange(tabKey as CreativeEngineTab)}
        />
      </TabsWrapper>
    }
  >
    {activatedTabs.has(CREATIVE_ENGINE_TABS.CreativeBriefs) && (
      <TabPanel hidden={activeTab !== CREATIVE_ENGINE_TABS.CreativeBriefs}>
        <CreativeBriefs />
      </TabPanel>
    )}
    {activatedTabs.has(CREATIVE_ENGINE_TABS.Avatars) && (
      <TabPanel hidden={activeTab !== CREATIVE_ENGINE_TABS.Avatars}>
        <Avatars />
      </TabPanel>
    )}
    {activatedTabs.has(CREATIVE_ENGINE_TABS.CastingProfile) && (
      <TabPanel hidden={activeTab !== CREATIVE_ENGINE_TABS.CastingProfile}>
        <CastingProfile />
      </TabPanel>
    )}
  </SectionLayout>
);

export default CreativeEngineView;
